<script lang="ts" setup>
import RModal from '~/components/organs/Modal.vue'

interface Props {
  title: string
  items: Link[]
}

interface Link {
  callback: () => void
  text: string
  showOnTablet?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'cancel'): void
}>()

const cancel = () => {
  emit('cancel')
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
defineExpose({
  closeModal,
})
</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5 class="modal-title fs-5">
        {{ title }}
      </h5>
    </template>

    <template #body>
      <div class="nav">
        <a
          v-for="(item, index) in items"
          :key="index"
          class="nav-link"
          :class="{ 'hide-on-tablet': item.showOnTablet === false }"
          href="#"
          @click.prevent="item.callback"
        >
          {{ item.text }}
        </a>
      </div>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.nav {
  display: flex;
  flex-direction: column;

  .nav-link {
    color: $gray-900;
    font-size: rem(14px);
    line-height: 150%;
    padding: rem(4px) rem(8px);
    
    &:not(:last-child) {
      border-bottom: 1px solid $gray-200;
    }
  }
}

.hide-on-tablet {
   @include media-breakpoint-up(md) {
    display: none;
  }
}
</style>
